import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInvestiment = _resolveComponent("FormInvestiment")!
  const _component_FormRecord = _resolveComponent("FormRecord")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NewModal, {
      title: 
        _ctx.type == 0
          ? 'Registro de una nueva inversión'
          : 'Registro de un nuevo registro'
      ,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:visible', e))
    }, {
      footer: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.type == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_FormInvestiment, { onAdd: _ctx.registerInvestiment }, null, 8, ["onAdd"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_FormRecord, {
                  id: _ctx.idRef,
                  onAdd: _ctx.registerRecord
                }, null, 8, ["id", "onAdd"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}